<template>
  <div class="container">
    <div class="row">
      <!--CSUB Seal and Page Title-->
      <div class="col-sm-12 text-center">
        <div class="seal"><img :src="seal" alt="CSUB Seal" /></div>
        <h1>CSU Bakersfield <br />{{ theSemester }} {{ theYear }} Commencement</h1>
        <h2 v-if="allCeremoniesCompleted">Congratulations, Class of {{ theYear }}!</h2>
      </div>

      <!--Watch Live-->
      <div class="col-sm-12 text-center" v-if="upcomingCeremony && upcomingCeremony.readyToStream">
        <div class="h3">
          <div class="ceremony-type" v-for="(type, index) in upcomingCeremony.gradType" :key="index">
            <b><i>{{ type }}</i></b>
          </div>
        </div>

        <br />

        <a class="btn btn-primary" :id="'watch-live-btn-' + upcomingCeremony.id">
          <!-- <i class="fa fa-television icon-large"></i>
          <i class="fa fa-tablet icon-large"></i>
          <i class="fa fa-mobile fa-lg"></i> -->
          <i class="fa fa-video-camera fa-lg"></i> &nbsp;
            Watch LIVE!</a>
      </div>

      <template v-else-if="!allCeremoniesCompleted">
        <!--Countdown-->
        <div class="col-sm-12 text-center">
          <!--<h3>Countdown to the livestream for the {{ gradType }}!</h3>=-->
          <div class="h3">
            Countdown to the livestream for the<br />
            <div class="ceremony-type" v-for="(type, index) in upcomingCeremony.gradType" :key="index">
              <b><i>{{ type }}</i></b>
            </div>
          </div>
          <p>
            Return to this page in<br />
            <b id="theDays"></b>
            <b id="theHours"></b>
            <b id="theMin"></b>
            <b id="theSec"></b>
          </p>
        </div>

        <!--Commencement Etiquette-->
        <div class="col-sm-12 text-center">
          <hr />
          <a class="btn btn-success" id="etiquetteBtn">
            <!-- <i class="fa fa-television icon-large"></i>
            <i class="fa fa-tablet icon-large"></i>
            <i class="fa fa-mobile fa-lg"></i> -->
            <i class="fa fa-video-camera fa-lg"></i> &nbsp;
            Watch the Commencement Etiquette Video</a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['ceremonies', 'allCeremoniesCompleted'],
  data () {
    return {
      seal: '/commencement/live/static/images/csub-logo-stacked.png',
      theYear: '2026',
      theSemester: 'Spring',
      upcomingCeremony: {}, // To store the upcoming ceremony
      evaluatedCeremonies: [] // To store the evaluated ceremonies
    }
  },
  watch: {
    ceremonies: { // Track updates to ceremonies array from parent component (allCeremonies.vue)
      handler (newArray, oldArray) {
        console.log('Watcher called')
        this.getCeremonies() // Get the latest ceremony data
        var vm = this // Store the Vue instance

        if (vm.upcomingCeremony) { // If upcoming ceremony exists
          var next = Date.parse(vm.upcomingCeremony.gradDate)
          var curr = Date.parse(moment().format('YYYY/MM/DD HH:mm:ss'))
          var diff = next - curr

          console.log('Upcoming ceremony: ' + vm.upcomingCeremony.id)

          console.log('next: ' + next + ', curr: ' + curr + ', diff: ' + diff)

          if (diff > 0 || ((diff * -1) < 10800000)) { // If upcoming ceremony hasn't yet occurred or 3-hr mark hasn't yet been reached
            if (!vm.evaluatedCeremonies.includes(vm.upcomingCeremony.id)) { // If upcoming ceremony isn't already being evaluated, add it to evaluatedCeremonies array and execute setTimeout functions
              console.log('Status for upcoming ceremony: Countdown')
              vm.evaluatedCeremonies.push(vm.upcomingCeremony.id)

              // Uncomment both setTimeout functions when within 24 days of ceremony dates
              setTimeout(function () { // Call readyToStream 15 min (900000 ms) before
                vm.readyToStream(vm.upcomingCeremony)
              }, (diff - 900000)) // 15 min (900000 ms) before upcoming ceremony starts

              setTimeout(function () { // Call ceremonyCompleted 3 hrs (10800000 ms) after
                vm.ceremonyCompleted(vm.upcomingCeremony)
              }, (diff + 10800000)) // 3 hrs (10800000 ms) after upcoming ceremony starts

              // 15 min (900000 ms)
              // 30 min (1800000 ms)
              // 2.5 hrs (9000000 ms)
              // 3 hrs (10800000 ms)
              // 3.5 hrs (12600000 ms)
              // 4 hrs (14400000 ms)
            } else { // Otherwise, if upcoming ceremony was already evaluated, do nothing and exit
              console.log('Status for upcoming ceremony: Streaming')
            }
          } else { // Otherwise, if upcoming ceremony already occurred, call ceremonyCompleted
            console.log('Status for upcoming ceremony: Completed')
            vm.ceremonyCompleted(vm.upcomingCeremony)
          }
        } else if (vm.allCeremoniesCompleted) { // Otherwise, if all ceremonies were completed, do nothing and exit
          console.log('All ceremonies completed, exit')
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getCeremonies: function () { // Get the latest ceremony data
      console.log('getCeremonies called')
      // Store the Vue instance
      let vm = this

      // Store upcoming ceremony
      this.upcomingCeremony = this.ceremonies.find(el => el.nextUp)

      // If an upcoming ceremony exists
      if (this.upcomingCeremony) {
        $(document).ready(function () {
          // var gradDate = vm.gradDate
          let gradDate = vm.upcomingCeremony.gradDate

          // Set up the countdown
          $('#timer').countdown(gradDate, function (event) {
            $(this).text(
              event.strftime('%D days %H hrs %M min %S seconds.')
            )
          })

          $('#theDays').countdown(gradDate, function (event) {
            $(this).text(
              event.strftime('%D')
            )
            $(this).append(
              event.strftime('<span>Days</span>')
            )
          })

          $('#theHours').countdown(gradDate, function (event) {
            $(this).text(
              event.strftime('%H')
            )
            $(this).append(
              event.strftime('<span>Hours</span>')
            )
          })

          $('#theMin').countdown(gradDate, function (event) {
            $(this).text(
              event.strftime('%M')
            )
            $(this).append(
              event.strftime('<span>Minutes</span>')
            )
          })

          $('#theSec').countdown(gradDate, function (event) {
            $(this).text(
              event.strftime('%S')
            )
            $(this).append(
              event.strftime('<span>Seconds</span>')
            )
          })

          // Add slide toggle for each "Watch LIVE" and "Etiquitte" buttons to show corresponding videos
          let watchBtn = $('#watch-live-btn-' + vm.upcomingCeremony.id)

          let watchEvent
          let watchHasEvents
          let etiquetteBtn = $('#etiquetteBtn')
          let etiquetteEvent
          let etiquetteHasEvents

          if (vm.upcomingCeremony.readyToStream) {
            watchEvent = $._data(watchBtn[0], 'events')
            watchHasEvents = (watchEvent != null)

            if (!watchHasEvents) {
              watchBtn.click(function () {
                $('#feature-box-' + vm.upcomingCeremony.id).slideToggle()
              })
            }
          } else {
            if (etiquetteBtn) {
              etiquetteEvent = $._data(etiquetteBtn[0], 'events')
              etiquetteHasEvents = (etiquetteEvent != null)

              if (!etiquetteHasEvents) {
                etiquetteBtn.click(function () {
                  $('.ettiquite-box').slideToggle()
                })
              }
            }
          }
        })
      }
    },
    ceremonyCompleted: function (upcomingCeremony) { // Triggered when ceremony is completed to update ceremonies array in parent component (allCeremonies.vue)
      console.log('Emitting ceremonyCompleted for ceremony ' + upcomingCeremony.id)
      this.$emit('ceremony-completed', upcomingCeremony)
    },
    readyToStream: function (upcomingCeremony) { // Triggered when an upcoming ceremony is ready to stream
      console.log('Emitting readyToStream for ceremony ' + upcomingCeremony.id)
      this.$emit('ready-to-stream', upcomingCeremony)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  p {
    font-size: 16px;
  }

  h2 {
    color: #ffd700;
    font-weight: bold;
    text-shadow: 2px 2px 10px black;
  }

  .seal {
    display: block;
    text-align: center;
  }

  .seal img {
    width: 30vmax;
    max-width: 250px;
  }

  .ceremony-type {
    margin: 5px 0;
    font-size: 28px;
  }

  #timer {
    font-family: block-timer;
    font-size: 25px;
    color: #fff;
    text-shadow: 3px 3px 5px #f90;
  }

  #theDays, #theHours, #theMin, #theSec {
    display: inline-block;
    padding-top: 3px;
    height: 125px;
    width: 125px;
    background: #2b2b2b;
    font-size: 60px;
    /* font-family: geneva; */
    margin: 10px 5px 5px;
    font-family: 'Oswald', sans-serif;
    font-weight: 400;
  }

  h3, .h3 {
    color: #ffd700;
    margin: 20px 0 30px;
  }

  .video-container {
    display: none;
    margin: 20px 0 40px;
  }

  .video-container iframe {
    width: 100%;
    max-width: 640px;
    max-height: 360px;
    display: block;
    margin: auto;
  }

  /* #etiquetteBtn {
    background-color: #357E35;
  } */

  /* a[id^='watch-live-btn-'] {
    font-size: 22px;
    padding: 15px 20px;
    text-transform: uppercase;
    font-weight: bold;
  } */

/* Watch Etiquette Video button  */
  #etiquetteBtn {
    /* background-color: #357E35; */
    background-color: #ffc72c;
    color: #003594;
    border: none;
    font-family: 'Oswald', sans-serif;
    text-transform: uppercase;
    transition: all 0.2s;
    padding: 12px;
    font-size: 16px;
    margin-bottom: 20px;
  }

    #etiquetteBtn:hover {
      background-color: #001a70;
      color: #ffffff;
    }

  /* Watch Live button */
  a[id^='watch-live-btn-'] {
    /* background-color: #357E35; */
    background-color: #ffc72c;
    color: #003594;
    border: none;
    font-family: 'Oswald', sans-serif;
    text-transform: uppercase;
    transition: all 0.2s;
    padding: 12px;
    font-size: 22px;
    margin-bottom: 20px;
  }

    a[id^='watch-live-btn-']:hover {
      background-color: #001a70;
      color: #ffffff;
    }

</style>



// WEBPACK FOOTER //
// src/components/header.vue